import React from 'react';
import { Text, Box } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
export const OwningSpaceIndicator = (
  <Box data-component="OwningSpaceIndicator" inline marginLeft={4} flexShrink={0}>
    <Text appearance="bodySmall" color="secondary">
      <FormattedMessage
        defaultMessage="(Owning space)"
        id="XhGFdz"
        description="Indicator that a space listing is the owning space"
      />
    </Text>
  </Box>
);
